import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AmusementService`;
const prtectedApiUrl = process.env.REACT_APP_Protected_API_URL;


const ApiAmusementService = {
  getAmusementService: (params) => {

    const url = `${baseServiceUrl}`;


    return ServiceApi.get(url, { params });
  },
  getAmusementServiceReserveDetail_V2: (params) => {

    const url = `${baseServiceUrl}/GetReserveDetail_V2`;

    return ServiceApi.get(url, { params });
  },
  createAmusementTestimonial: (params) => {

    const url = `${prtectedApiUrl}${baseServiceUrl}/createAmusementTestimonial`;

    return ServiceApi.post(url, params);
  },
  updateAmusementTestimonialLikeOrDislike: (params) => {

    const url = `${prtectedApiUrl}${baseServiceUrl}/updateAmusementTestimonialLikeOrDislike`;

    return ServiceApi.put(url, params);
  },
  getAllServicesWithItems: () => {

    const url = `${baseServiceUrl}/getAllServicesWithItems`;

    return ServiceApi.get(url);
  },
};

export default ApiAmusementService;